/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosportsSliderViewProps } from './hosports-slider';

export default (props: IHosportsSliderViewProps) => {
    return (
        <h2>{'HO SPORTS SLIDER'}</h2>
    );
};
